if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(
          ".hero--video-background",
        );
        if (this.video_section) {
          this.checkAndPlayVideoSection(this.video_section);
        } else if (this.video_background_section) {
          this.checkAndPlayBackgroundVideoSection(
            this.video_background_section,
          );
        }
      }

      checkAndPlayBackgroundVideoSection(video_background_section) {
        const hero_overlay =
          video_background_section.querySelector(".hero__overlay");
        const has_video = !!video_background_section.querySelector("video");
        if (hero_overlay && has_video) {
          hero_overlay.addEventListener("touchstart", () =>
            this.playVideo(this.getVisibleVideo(video_background_section)),
          );
          hero_overlay.addEventListener("click", () =>
            this.playVideo(this.getVisibleVideo(video_background_section)),
          );
        }
      }

      checkAndPlayVideoSection(video) {
        const has_video = !!video.querySelector("video");
        if (has_video) {
          video.addEventListener("touchstart", () =>
            this.playVideo(this.getVisibleVideo(video)),
          );
          video.addEventListener("click", () =>
            this.playVideo(this.getVisibleVideo(video)),
          );
        }
      }

      // A section can render two <video> tags (desktop + mobile) hidden/shown
      // via CSS depending on breakpoint. Always resolve the one actually on
      // screen instead of assuming there is only one.
      getVisibleVideo(container) {
        const videos = container.querySelectorAll("video");
        if (videos.length < 2) return videos[0] || null;
        return (
          Array.from(videos).find((videoEl) => videoEl.offsetParent !== null) ||
          videos[0]
        );
      }

      playVideo(video_element) {
        if (video_element && !video_element.playing) {
          video_element.play();
        }
      }

      disconnectedCallback() {
        if (this.video_section) {
          this.video_section.removeEventListener("touchstart", this.playVideo);
          this.video_section.removeEventListener("click", this.playVideo);
        }
        if (this.video_background_section) {
          const hero_overlay =
            this.video_background_section.querySelector(".hero__overlay");
          const video_element =
            this.video_background_section.querySelector("video");
          if (video_element) {
            hero_overlay.removeEventListener("touchstart", () =>
              this.playVideo(video_element),
            );
            hero_overlay.removeEventListener("click", () =>
              this.playVideo(video_element),
            );
          }
        }
      }
    },
  );
}
